import { yupResolver } from '@hookform/resolvers/yup';
import type { Client } from '@src/clients/domain/Client';
import { AddClientUserFormInputs } from '@src/clientUser/manage/add/AddClientUserFormInputs';
import {
  ClientUserEmailField,
  ClientUserNameField,
  ClientUserPhoneField,
} from '@src/clientUser/manage/ClientUserFormInputs';
import { ClientUsersClient } from '@src/clientUser/manage/ClientUsersClient';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';

export const useCreateClientUser = ({
  client,
  onError,
  onSuccess,
}: {
  client: Client;
  onError: () => void;
  onSuccess: () => void;
}) => {
  const {
    register,
    formState: { errors },
    getValues,
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(AddClientUserFormInputs),
  });

  const { mutate } = useMutation({
    mutationFn: () =>
      ClientUsersClient.create({
        clientId: client.id,
        name: getValues(ClientUserNameField.fieldName)!,
        email: getValues(ClientUserEmailField.fieldName)?.toLowerCase() ?? '',
        phone: getValues(ClientUserPhoneField.fieldName)!,
      }),
    onError,
    onSuccess,
  });

  return {
    errors,
    register,
    submit: handleSubmit(() => mutate()),
    reset,
  };
};
